import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { UserDetailsContainer } from '~features/users';

import PageNotFoundPage from '../other/pageNotFoundPage';
import Page from '../page';

const UserDetailsPage = () => {
	const { t } = useTranslation();
	const { id } = useParams();

	if (!id) {
		return <PageNotFoundPage />;
	}

	return (
		<Page title={t('userDetails')}>
			<UserDetailsContainer userId={id} />
		</Page>
	);
};

export default UserDetailsPage;
